// extracted by mini-css-extract-plugin
module.exports = {"main":"DraggableModalWrapper_main__st7bj","header":"DraggableModalWrapper_header___QV3S","line":"DraggableModalWrapper_line__i_0vi"};